module.exports = __webpack_public_path__ + "static/media/bishop2.66efe4ba.jpg";